import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const CustomSegmentedControl = ({
  name,
  options,
  setValue,
  className,
  style,
  defaultValue,
}) => {
  // Find the default selected option or use the first one
  const findDefaultSelected = () => {
    const defaultOption = options.find(option => option.default === true);
    if (defaultOption) return defaultOption.value;
    return options.length > 0 ? options[0].value : '';
  };

  const [selectedValue, setSelectedValue] = useState(defaultValue || findDefaultSelected());

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const handleClick = (value) => {
    setSelectedValue(value);
    if (setValue) {
      setValue(value);
    }
  };

  const containerStyles = {
    display: 'flex',
    border: '1px solid #ddd',
    backgroundColor: '#f9f9f9',
    borderRadius: '0',
    ...style
  };

  const optionStyles = (isSelected) => ({
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: isSelected ? '#c00000' : '#ffffff',
    color: isSelected ? '#ffffff' : '#bb0000',
    // fontWeight: isSelected ? 'bold' : 'normal',
    flex: 1,
    textAlign: 'center',
    transition: 'all 0.5s ease',
    userSelect: 'none',
    border: isSelected ? 'none' : '1px solidrgb(230, 231, 231)',
    borderLeft: isSelected ? 'none' : (options[0].value === selectedValue ? '1px solid #95989a' : 'none'),
    position: 'relative',
  });

  return (
    <div 
      className={className} 
      style={containerStyles}
      role="tablist"
      aria-label={name}
    >
      {options.map((option, index) => (
        <div
          key={`${option.value}-${index}`}
          onClick={() => handleClick(option.value)}
          style={{
            ...optionStyles(selectedValue === option.value),
            // width: option.width ? option.width : '100px !important'
          }}
          role="tab"
          aria-selected={selectedValue === option.value}
          tabIndex={selectedValue === option.value ? 0 : -1}
          id={`${name}-${option.value}`}
          aria-controls={`${name}-panel-${option.value}`}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
};

CustomSegmentedControl.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
      default: PropTypes.bool,
      width: PropTypes.string,
    })
  ).isRequired,
  setValue: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.string,
};

export default CustomSegmentedControl;